import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import { toast } from "sonner";
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { FileText, Printer, Loader2 } from "lucide-react";

async function openPdf(url, mode, filename) {
  const r = await api.get(url, { responseType: "blob" });
  const href = URL.createObjectURL(new Blob([r.data], { type: "application/pdf" }));
  if (mode === "print") {
    const w = window.open(href, "_blank");
    if (!w) toast.error("Permita pop-ups para imprimir");
    else w.addEventListener("load", () => w.print());
  } else {
    const a = document.createElement("a");
    a.href = href; a.download = filename; a.click();
  }
}

export function TranscriptDialog({ cls, onClose }) {
  const [students, setStudents] = useState(null);
  const [busy, setBusy] = useState("");
  useEffect(() => {
    if (!cls) return;
    setStudents(null);
    api.get("/students", { params: { class_id: cls.id } })
      .then((r) => setStudents((r.data || []).filter((s) => s.enrollment_status === "MATRICULADO")))
      .catch(() => setStudents([]));
  }, [cls]);
  if (!cls) return null;
  const run = async (key, url, mode, filename) => {
    setBusy(key);
    try { await openPdf(url, mode, filename); } catch { toast.error("Falha ao gerar o histórico escolar"); } finally { setBusy(""); }
  };
  const all = `/classes/${cls.id}/transcripts/pdf`;
  return (
    <Dialog open onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="max-h-[90vh] overflow-y-auto sm:max-w-2xl" data-testid="transcript-dialog">
        <DialogHeader>
          <DialogTitle>Histórico Escolar — Turma {cls.name}</DialogTitle>
          <DialogDescription>Modelo oficial do Estado do Rio de Janeiro (SEEDUC-RJ). Emissão individual ou de toda a turma.</DialogDescription>
        </DialogHeader>
        <div className="flex flex-wrap gap-2">
          <Button onClick={() => run("all-dl", all, "download", `historicos_turma_${cls.name}.pdf`)} disabled={!!busy || !students?.length} className="bg-orange-500 hover:bg-orange-600" data-testid="transcript-all-download">
            {busy === "all-dl" ? <Loader2 className="mr-1.5 h-4 w-4 animate-spin" /> : <FileText className="mr-1.5 h-4 w-4" />}Baixar todos (PDF)
          </Button>
          <Button variant="outline" onClick={() => run("all-pr", all, "print")} disabled={!!busy || !students?.length} data-testid="transcript-all-print">
            {busy === "all-pr" ? <Loader2 className="mr-1.5 h-4 w-4 animate-spin" /> : <Printer className="mr-1.5 h-4 w-4" />}Imprimir todos
          </Button>
        </div>
        {students === null ? <p className="py-6 text-center text-sm text-slate-400">Carregando...</p>
          : !students.length ? <p className="py-6 text-center text-sm text-slate-500">Nenhum estudante matriculado.</p>
          : (
            <div className="divide-y rounded-lg border" data-testid="transcript-student-list">
              {students.map((s) => {
                const url = `/classes/${cls.id}/transcripts/${s.id}/pdf`;
                return (
                  <div key={s.id} className="flex flex-col gap-2 p-3 sm:flex-row sm:items-center sm:justify-between" data-testid={`transcript-row-${s.id}`}>
                    <div className="min-w-0"><div className="truncate font-medium text-slate-800">{s.full_name}</div><div className="text-xs text-slate-400">Matrícula {s.registration}</div></div>
                    <div className="flex shrink-0 gap-2">
                      <Button size="sm" variant="outline" onClick={() => run(`dl-${s.id}`, url, "download", `historico_${s.registration}.pdf`)} disabled={!!busy} data-testid={`transcript-download-${s.id}`}>
                        {busy === `dl-${s.id}` ? <Loader2 className="h-3.5 w-3.5 animate-spin" /> : <FileText className="h-3.5 w-3.5" />}<span className="ml-1">PDF</span>
                      </Button>
                      <Button size="sm" variant="outline" onClick={() => run(`pr-${s.id}`, url, "print")} disabled={!!busy} data-testid={`transcript-print-${s.id}`}>
                        <Printer className="h-3.5 w-3.5" /><span className="ml-1">Imprimir</span>
                      </Button>
                    </div>
                  </div>
                );
              })}
            </div>
          )}
        <p className="text-xs text-slate-400">Carga horária vem do cadastro de Disciplinas; séries anteriores vêm do cadastro do aluno (Estudos anteriores).</p>
      </DialogContent>
    </Dialog>
  );
}
